import { Icon, TextLink } from '@petsmart-ui/sparky';

import { trackNavigationHeaderClick, useServicesLinkClick } from '../../../../../shared';
import type { NavigationPanel } from '../../../../../types';
import { LinksColumns } from './links-columns';
import { VisualItemsGrid } from './visual-items-grid';
import './panel-body.scss';

type PanelBodyProps = {
    panel: NavigationPanel;
    selectionPath: string[];
    showOverviewLink?: boolean;
};

export function PanelBody({ panel, selectionPath, showOverviewLink = true }: Readonly<PanelBodyProps>) {
    const overviewLink = panel.overviewLink;

    const handleServicesLinkClick = useServicesLinkClick();

    return (
        <div className="panel-body">
            {panel.content.kind === 'columns' ? (
                <LinksColumns
                    columns={panel.content.columns}
                    desktopColumnCount={panel.content.desktopColumnCount}
                    selectionPath={selectionPath}
                />
            ) : (
                <VisualItemsGrid
                    items={panel.content.items}
                    layout={panel.content.layout}
                    selectionPath={selectionPath}
                />
            )}
            {showOverviewLink && overviewLink && (
                <TextLink
                    href={overviewLink.href}
                    className="panel-body__overview-link sparky-c-text-passage--lg"
                    rel={overviewLink.openInNewTab ? 'noopener noreferrer' : undefined}
                    target={overviewLink.openInNewTab ? '_blank' : undefined}
                    onClick={event => {
                        trackNavigationHeaderClick({
                            selection: [...selectionPath, overviewLink.label],
                            linkUrl: overviewLink.href,
                            navSection: 'main nav',
                        });
                        handleServicesLinkClick({
                            event,
                            link: overviewLink.href,
                            shouldOpenInNewTab: overviewLink.openInNewTab,
                        });
                    }}
                >
                    {overviewLink.label}
                    <Icon
                        name="chevron-right"
                        size="lg"
                        className="panel-body__overview-link-icon"
                        aria-hidden="true"
                    />
                </TextLink>
            )}
        </div>
    );
}
